<template>

	<div class="invite-index-page">

		<div class="logo" v-if='!isWeiXin'>
			<van-image :src="require('../../assets/images/logo_w.png')"></van-image>
		</div>

		<p v-if='!isWeiXin' class="title">{{ translate('invite_title') }}</p>
		<p v-if='!isWeiXin' class="subtitle"><span>{{ translate('invite_subtitle') }}</span></p>
		
		
		<van-form @submit="onSubmit" class="content" ref="formItem" :show-error-message="false" v-if='!isWeiXin'>

			<p style="text-align: center;font-size: 14px;padding-bottom: 15px">{{ translate('invite_join_zydf') }}</p>

			<van-row>
				<van-col span="6">
					<van-field
						v-model="formItem.country_code"
						readonly
						@click="showPicker = true"
						style="margin-bottom:15px;background: #f0f4ff;padding: 5px 10px;"
					/>
				</van-col>
				<van-popup v-model="showPicker" round position="bottom" >
					<van-picker
						show-toolbar
						:columns="country_codes"
						@cancel="showPicker = false"
						@confirm="onConfirm"
					/>
				</van-popup>

				<van-col span="18">
					<van-field
						v-model="formItem.telephone"
						type="tel"
						:placeholder="translate('please_input') + translate('telephone')"
						:rules="[{ required: true, trigger: 'onSubmit', message: translate('please_input') + translate('telephone') }]"
						style="margin-bottom:15px;background: #f0f4ff;padding: 5px 10px;"
					/>
				</van-col>
			</van-row>

			<van-field
				v-model="formItem.sms_code"
				type="number"
				:placeholder="translate('please_input') + translate('verify_code')"
				:rules="[{ required: true, trigger: 'onSubmit', message: translate('please_input') + translate('verify_code') }]"
				style="margin-bottom:15px;background: #f0f4ff;padding: 5px 10px;"
			>
				<template #button>
					<van-button size="mini" type="primary" style="background:#224A9F;border:none;" block native-type="button" :disabled="disabledSendCode" @click="sendSMSCode">{{send_text}}</van-button>
				</template>
			</van-field>
			
			<van-row>
				<van-col span="24">
					<van-button block style="background-image: linear-gradient(to right , #57B9EA, #224A9F);border: none;color: #FFF;" native-type="submit">{{ translate('next_step') }}</van-button>
				</van-col>
			</van-row>

		</van-form>
		<van-overlay :show="isWeiXin">
				<div class="wrapper">
					<div class="weixin-browser"></div>
				</div>
			</van-overlay>

	</div>
</template>

<script>
	export default {
		name: 'invite_index',
		data() {
			return {
				showPicker: false,

				columns : ['86', '852', '853'],

				formItem: {
					invite_id: "",
					esop_team_id: 0,
					code: "",
					country_code: "86",
					telephone: "",
					sms_code: "",
				},

				send_text: this.translate('send_verify_code'),
				disabledSendCode: false,

				second: 60,
				clock: "",

				resourceURL: this.$axios.defaults.resourceURL,

				isWeiXin: false,

				country_codes: [],
				
			}
		},
		mounted() {
			if (this.$route.query.code == "" || this.$route.query.code == undefined) {
				this.$router.replace('/nologin')
			} else {
				this.formItem.code = this.$route.query.code

				if (this.$route.query.team != undefined) {
					this.formItem.esop_team_id = this.$route.query.team
				}
			}

			this.$axios({
				method: 'post',
				url: 'invite/dicts', 
			}).then ((res) => {
				if (res.success) {
					let country_codes = []

					res.data.country_codes.forEach(item => {
						console.log('+++++++++++++++'+item.code);
						country_codes.push(item.code)
					})

					this.country_codes = country_codes
		
				} else {			
					this.$toast.fail(res.error_text)
				}
			})

			//window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
			var ua = window.navigator.userAgent.toLowerCase();
			//alert(JSON.stringify(ua))
			//通过正则表达式匹配ua中是否含有MicroMessenger字符串
			if(ua.match(/MicroMessenger/i) == 'micromessenger'){
				this.isWeiXin = true
			} else{
				this.isWeiXin = false
			}
		},
		methods: {

			onConfirm(value) {
				this.formItem.country_code = value
				this.showPicker = false
			},

			doLoop() {
				this.second--;
				if(this.second > 0){
					this.send_text = this.second + this.translate('second')
				}else{
					clearInterval(this.clock); //清除js定时器
					this.disabledSendCode = false;
					this.send_text = this.translate('send_verify_code')
					this.second = 60; //重置时间
				}
			},

			sendSMSCode() {

				if(this.formItem.telephone == ""){
					this.$toast.fail(this.translate('please_enter_valid_phone_number'))
					return false
				}

				this.$axios({
					method: 'post',
					url: 'invite/sendsmscode', 
					data: this.formItem
				}).then ((res) => {
					if (res.success && res.data.invite_id) {
						this.formItem.invite_id = res.data.invite_id

						this.$toast.success(this.translate('verify_code_send_success'))

						this.disabledSendCode = true

						this.send_text = this.second + this.translate('second')
						
						this.clock = setInterval(this.doLoop, 1000); //一秒执行一次
					} else if (res.error_text == this.translate('phone_is_registered')) {
						this.$dialog.confirm({
							message: this.translate('phone_is_registered_download'),
							confirmButtonText: this.translate('to_download') 
						}).then(() => {
							this.$router.replace('/invite/download')
						}).catch(() => {

						})
					} else {
						this.$toast.fail(res.error_text)
					}
				})
			},
			
			onSubmit() {
				if(this.formItem.invite_id == ""){
					this.$toast.fail(this.translate('refresh_the_page'))
					return false
				}

				this.$axios({
					method: 'post',
					url: 'invite/checksmscode',
					data: this.formItem
				}).then ((res) => {
					if (res.success) {
						this.$router.replace('/invite/password?invite_id=' + this.formItem.invite_id)
					}else{
						this.$toast.fail(res.error_text)
					}
				})
			}
		},
	}
</script>

<style scoped>
.send-code-btn {
	display:inline-block;
	text-align:right;
	color:#FDF773;
	transform: translateY(10px);
}
</style>